<h4 mat-dialog-title>
    {{ 'poll_creation_success.title' | translate }}
</h4>
<div mat-dialog-content class="px-5 py-3">
   
    <div class="row">
        <div class="col-md-6 column-center">
            <div class="image-container">
                <img src="https://res.cloudinary.com/teammood/image/upload/c_scale,w_250/v1741252701/app/success.png" class="h-100">
            </div>
        </div>
        <div class="col-md-6 column-center">
            <p class="alert alert-success w-100">{{ 'poll_creation_success.desc' | translate }}</p>
            <p class="text">{{ 'poll_creation_success.info1' | translate }}</p>
            <p class="text">{{ 'poll_creation_success.info2' | translate }} <a routerLink="/setup/polls" [mat-dialog-close]="true">{{ 'poll_creation_success.info3' | translate }} <i class="fa-solid fa-up-right-from-square ps-1"></i></a></p>
        </div>
    </div>    
</div>
<div mat-dialog-actions>
<button [mat-dialog-close]="true"
    class="btn"
    ngClass="btn-default">
    {{ 'close' | translate}}
</button>
</div>